"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _readOnlyError(r) { throw new TypeError('"' + r + '" is read-only'); }
/**
 *  Konfigurator Feste Seitenwand ( snippets/product-festeseitenwand-confi.liquid ) ,
 *  API : fixed-wall-* . Ablauf , Preis und Warenkorb : confi-wall.js
 */
(function (root) {
  var Wall = typeof module !== 'undefined' && module.exports ? require('./confi-wall.js') : root.ConfiWall;

  //  Einbauseite zuerst : vorne eine Höhe ( gerade Wand , Frontwand-Tabelle ) ,
  //  links / rechts Höhe hinten und vorne ( verschieden : schräge Seitenwand ) .
  //  Breite im Frontend immer bis 500 cm ( max im Snippet ) .
  var Positions = ['left', 'right', 'front'];
  var Sides = ['left', 'right'];
  var position = function position(values) {
    return Positions.includes(values.position) ? values.position : 'left';
  };
  var atSide = function atSide(values) {
    return Sides.includes(position(values));
  };

  //  Höhen hinten / vorne im Request , vorne beide aus dem einen Feld
  var heights = function heights(values) {
    return atSide(values) ? {
      front: Wall.number(values.heightFront),
      back: Wall.number(values.heightBack)
    } : {
      front: Wall.number(values.height),
      back: Wall.number(values.height)
    };
  };

  //  Höhen 50–350 cm ( min / max im Snippet )
  var Min_Height = 50;
  var Max_Height = 350;

  //  Glasfarbe gilt nur für Tür und Fenster
  var withDoorOrWindow = function withDoorOrWindow(values) {
    return values.door !== undefined && values.door !== '' && values.door !== '-' || (Wall.number(values.window) || 0) > 0;
  };
  var definition = {
    confi: 'festeseitenwand-confi',
    endpoint: 'fixed-wall',
    wallType: 'fixedWall',
    required: function required(values) {
      return atSide(values) ? ['width', 'heightFront', 'heightBack'] : ['width', 'height'];
    },
    body: function body(values) {
      var _heights = heights(values),
        front = _heights.front,
        back = _heights.back;
      var body = {
        width: Wall.number(values.width),
        heightFront: front,
        heightBack: back,
        material: values.material,
        frameColor: values.frameColor,
        position: position(values),
        door: values.door || '-',
        window: Wall.number(values.window) || 0,
        underConstruction: Wall.bool(values.underConstruction)
      };
      if (withDoorOrWindow(values)) {
        body.glassColor = values.glassColor;
      }
      return body;
    },
    rules: function rules(values) {
      var side = atSide(values);
      var rules = {
        hidden: {
          'height-single': side,
          'heights-side': !side,
          'door-window-glass': !withDoorOrWindow(values)
        },
        set: {},
        max: {
          heightFront: Max_Height
        }
      };
      //  Höhe vorne nicht höher als hinten : Grenze am Feld , und wird hinten
      //  niedriger , geht vorne mit
      var back = Wall.number(values.heightBack);
      if (side && back !== null && back >= Min_Height && back <= Max_Height) {
        rules.max.heightFront = back;
        var front = Wall.number(values.heightFront);
        if (front !== null && front > back) {
          rules.set.heightFront = String(back);
        }
      }
      return rules;
    },
    //  „Einbauseite: Vorne“ nicht anzeigen
    properties: function properties(list, data) {
      return Wall.withoutFrontPosition(list, data);
    },
    fromInfo: function fromInfo(data) {
      var _ref, _data$glassColor;
      var door = data.door && _typeof(data.door) === 'object' ? data.door.door : data.door;
      var windows = data.windows && _typeof(data.windows) === 'object' ? data.windows.quantity : data.window;
      var glassColor = (_ref = (_data$glassColor = data.glassColor) !== null && _data$glassColor !== void 0 ? _data$glassColor : data.door && data.door.glassColor) !== null && _ref !== void 0 ? _ref : data.windows && data.windows.glassColor;
      var underConstruction = data.underConstruction !== null && data.underConstruction !== undefined && data.underConstruction !== false;
      //  Ohne gespeicherte Seite : gleiche Höhen vorne , sonst links
      var front = Wall.number(data.heightFront);
      var back = Wall.number(data.heightBack);
      var saved = Positions.includes(data.position) ? data.position : front !== null && front === back ? 'front' : 'left';
      return {
        position: saved,
        width: data.width,
        height: data.heightFront,
        heightFront: data.heightFront,
        heightBack: data.heightBack,
        material: data.material,
        frameColor: data.frameColor,
        door: door || '-',
        window: windows !== null && windows !== void 0 ? windows : 0,
        glassColor: glassColor,
        underConstruction: underConstruction ? 'true' : 'false'
      };
    }
  };
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = definition;
  }
  if (root && root.document) {
    root.document.addEventListener('DOMContentLoaded', function () {
      return Wall.start(definition);
    });
  }
})(typeof window !== 'undefined' ? window : null);